import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PasswordService {

  constructor(private httpClient: HttpClient) {
  }

  post(currentPassword: string, newPassword: string, provider?: string): Observable<boolean> {
    const authApiUrl = !!provider
      ? environment.authApiUrl[provider]
      : environment.authApiUrl.default;

    return this.httpClient.post(`${authApiUrl}/password/change`, {
      currentPassword,
      newPassword
    }) as Observable<boolean>;
  }

  reset(username: string, provider?: string): Observable<boolean> {
    const authApiUrl = !!provider
      ? environment.authApiUrl[provider]
      : environment.authApiUrl.default;

    return this.httpClient.post(`${authApiUrl}/password/reset`, {
      username
    }) as Observable<boolean>;
  }

}